import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ExploreTopicDocument, ExploreTopicResponse } from 'services/types';

interface TopicDetailState {
  topics: Record<string, ExploreTopicResponse>;
  popularDocuments: ExploreTopicDocument[];
  popularLoading: boolean;
  currentTopicId: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: TopicDetailState = {
  topics: {},
  popularDocuments: [],
  popularLoading: true,
  currentTopicId: null,
  loading: false,
  error: null,
};

const topicDetailSlice = createSlice({
  name: 'topicDetail',
  initialState,
  reducers: {
    setCurrentTopic(state, action: PayloadAction<string>) {
      state.currentTopicId = action.payload;
    },
    setTopicDetail(state, action: PayloadAction<ExploreTopicResponse>) {
      state.topics[action.payload.id] = action.payload;
      state.loading = false;
      state.error = null;
    },
    setPopularDocuments(state, action: PayloadAction<ExploreTopicDocument[]>) {
      state.popularDocuments = action.payload;
      state.popularLoading = false;
    },
    setPopularLoading(state, action: PayloadAction<boolean>) {
      state.popularLoading = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  setCurrentTopic,
  setTopicDetail,
  setPopularDocuments,
  setPopularLoading,
  setLoading,
  setError,
} = topicDetailSlice.actions;
export default topicDetailSlice.reducer;
